export default __webpack_public_path__ + "static/media/gmx-logo-with-name.03a4464f.svg";